import React,{useState} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiX,FiChevronLeft,FiChevronRight}=FiIcons;

function Gallery() {
  const [selectedImage,setSelectedImage]=useState(null);
  
  const images=[
    'https://i.ibb.co/FqL7gxFW/images-1.jpg','https://i.ibb.co/QFW6zk7Z/images-2.jpg','https://i.ibb.co/0Vc6tgzx/images-3.jpg','https://i.ibb.co/23t9zDr8/images-4.jpg','https://i.ibb.co/ZzHbcGkQ/images-5.jpg','https://i.ibb.co/7x6r8tQN/images-6.jpg','https://i.ibb.co/zhZNn0gv/images-7.jpg','https://i.ibb.co/C3rPYRRz/images-8.jpg','https://i.ibb.co/ksBb7LJd/images-9.jpg','https://i.ibb.co/8nyj4b12/images-10.jpg','https://i.ibb.co/vCmDP3wK/images-11.jpg','https://i.ibb.co/4Zp6QVYt/images-12.jpg','https://i.ibb.co/cXxmxhgM/images-13.jpg','https://i.ibb.co/sd3gSpHG/images-14.jpg','https://i.ibb.co/Kp3KJQnf/images-15.jpg','https://i.ibb.co/R4s09jCP/images-16.jpg','https://i.ibb.co/rRYNPm5h/images-17.jpg','https://i.ibb.co/JR0yKw0J/images-18.jpg','https://i.ibb.co/DDHKWmHb/images-19.jpg','https://i.ibb.co/FqCpH24J/images-20.jpg','https://i.ibb.co/dsqBnRWj/images-21.jpg','https://i.ibb.co/TMtkD9Rz/images-22.jpg','https://i.ibb.co/YBwWT1dm/images-23.jpg','https://i.ibb.co/1YjgKxdN/images-24.jpg','https://i.ibb.co/yc6GDt19/images-25.jpg','https://i.ibb.co/93NkDnrb/images-26.jpg','https://i.ibb.co/ynQjz0LZ/images-27.jpg','https://i.ibb.co/zTgyZx1v/images-28.jpg','https://i.ibb.co/99THYS3q/images-29.jpg','https://i.ibb.co/MDd1PBTM/images-30.jpg','https://i.ibb.co/0j6XMDRq/images-31.jpg','https://i.ibb.co/fznkLzZq/images-32.jpg','https://i.ibb.co/fGK6wmPv/images-33.jpg','https://i.ibb.co/rR7ntyML/images-34.jpg','https://i.ibb.co/6cpPK16S/images-35.jpg','https://i.ibb.co/p6f20PQH/images-36.jpg','https://i.ibb.co/q3JypZvv/images-37.jpg','https://i.ibb.co/tpPwGJG9/images-38.jpg','https://i.ibb.co/RkjH2tP4/images-39.jpg','https://i.ibb.co/d0yNhF3j/images-40.jpg','https://i.ibb.co/WpD89ND4/images-41.jpg','https://i.ibb.co/04gvG4B/images-42.jpg','https://i.ibb.co/QvF36Kh1/images-43.jpg','https://i.ibb.co/qFDvsLH4/images-44.jpg','https://i.ibb.co/S41nnrZY/images-45.jpg'
  ];

  const openModal=(index)=> {
    setSelectedImage(index);
  };

  const closeModal=()=> {
    setSelectedImage(null);
  };

  const nextImage=()=> {
    setSelectedImage((prev)=> (prev + 1) % images.length);
  };

  const prevImage=()=> {
    setSelectedImage((prev)=> (prev - 1 + images.length) % images.length);
  };

  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} transition={{duration: 0.5}} className="flex-1" >
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-black py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.h1 initial={{y: 50,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.2,duration: 0.8}} className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6" >
            Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">Gallery</span>
          </motion.h1>
          <motion.p initial={{y: 50,opacity: 0}} animate={{y: 0,opacity: 1}} transition={{delay: 0.4,duration: 0.8}} className="text-xl text-gray-400 max-w-2xl mx-auto" >
            Explore our work and see the artistry behind every cut
          </motion.p>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {images.map((image,index)=> (
              <motion.div key={index} initial={{y: 50,opacity: 0}} whileInView={{y: 0,opacity: 1}} transition={{delay: index * 0.05,duration: 0.8}} viewport={{once: true}} className="group cursor-pointer overflow-hidden rounded-lg border border-yellow-500/20 hover:border-yellow-500/50 transition-all duration-300" onClick={()=> openModal(index)} >
                <div className="relative aspect-square overflow-hidden">
                  <img src={image} alt={`Gallery image ${index + 1}`} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
                  <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                    <span className="text-white font-semibold">View Image</span>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      <AnimatePresence>
        {selectedImage !==null && (
          <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4" onClick={closeModal} >
            <motion.div initial={{scale: 0.5,opacity: 0}} animate={{scale: 1,opacity: 1}} exit={{scale: 0.5,opacity: 0}} className="relative max-w-4xl max-h-full" onClick={(e)=> e.stopPropagation()} >
              <img src={images[selectedImage]} alt={`Gallery image ${selectedImage + 1}`} className="max-w-full max-h-full object-contain rounded-lg" />
              
              {/* Close Button */}
              <button onClick={closeModal} className="absolute top-4 right-4 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors duration-200" >
                <SafeIcon icon={FiX} className="h-6 w-6" />
              </button>
              
              {/* Navigation Buttons */}
              <button onClick={prevImage} className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors duration-200" >
                <SafeIcon icon={FiChevronLeft} className="h-6 w-6" />
              </button>
              <button onClick={nextImage} className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors duration-200" >
                <SafeIcon icon={FiChevronRight} className="h-6 w-6" />
              </button>
              
              {/* Image Counter */}
              <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/50 text-white px-4 py-2 rounded-full">
                {selectedImage + 1} / {images.length}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
}

export default Gallery;